<template>
  <transition name="fade">
    <span class="background-container">
      <component :is="background" class="background" />
      <slot />
    </span>
  </transition>
</template>

<script>
import Background from '@/assets/images/logos/sellia-logo.svg'
import BG1 from '@/assets/images/backgrounds/bg.svg';
import BG2 from '@/assets/images/backgrounds/bg2.svg';
import BG3 from '@/assets/images/backgrounds/bg3.svg';
import BG4 from '@/assets/images/backgrounds/bg4.svg';
import BG5 from '@/assets/images/backgrounds/bg5.svg';

export default {
    components: {
        Background,
        BG1,
        BG2,
        BG3,
        BG4,
        BG5
    },
    data(){
      return {
       allBackgrounds: [BG1, BG2, BG3, BG4, BG5]
      }
    },
    computed: {
     background(){
       return this.allBackgrounds[Math.floor(Math.random() * this.allBackgrounds.length)];
     }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/views/_login.scss";
</style>
